// Hooks
import { useAppSelector } from "../../../../services/StoreHelper";

// Components
import Card from "./Card/Card";

// Styles
import membership_styles from "./memberships_styles";

function Memberships({ refresh }: { refresh: () => void }) {
  const { app_loading, agreements, club } = useAppSelector((state) => state.app);

  // 🔹 Toggle language here (can be lifted later)
  const { usesSpanish } = club;

  const headlineText = usesSpanish
    ? "Membresías actuales:"
    : "Current Memberships:";

  return (
    <div style={membership_styles.membership_list}>
      <div style={{ ...membership_styles.headline, display: "none" }}>
        {headlineText}
      </div>

      {!app_loading && agreements.length > 0 && (
        <div style={membership_styles.cards}>
          {agreements.map((contract: any, index: number) => (
            <Card key={index} contract={contract} refresh={refresh} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Memberships;